import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PartnerStore } from '@app/config/partner-store';
import { Store } from '@app/config/store';
import { FSLUG, MSLUG } from '@app/constant/features';

export function userAuth(): CanActivateFn {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return (route, state) => {
    const store = inject(Store);
    const partnerStore = inject(PartnerStore);
    const router: Router = inject(Router);

    if (partnerStore.partnerAuth()) {
      partnerStore.clearSession();
      router.navigate(['login']);
      return true;
    }

    // unauthorised check and redirect
    if (!store.authToken()) {
      router.navigate(['login']);
      return false;
    }

    return true;
  };
}

export function publicAuth(): CanActivateFn {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return (route, state) => {
    const store = inject(Store);
    const partnerStore = inject(PartnerStore);
    const router: Router = inject(Router);

    if (partnerStore.partnerAuth()) {
      partnerStore.clearSession();
      router.navigate(['login']);
      return true;
    }

    // unauthorised check and redirect
    if (store.authToken()) {
      router.navigate(['redirect']);
      return false;
    }

    return true;
  };
}

export function userAccessAuth(featureSlug: FSLUG): CanActivateFn {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return (route, state) => {
    const store = inject(Store);
    const router: Router = inject(Router);

    if (!store.userAccess()[featureSlug]) {
      router.navigate(['/not-authorised']);
      return false;
    }
    return true;
  };
}

export function moduleAccess(moduleSlug: MSLUG): CanActivateFn {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return (route, state) => {
    const store = inject(Store);
    const router: Router = inject(Router);

    if (!store.moduleAccess()[moduleSlug]) {
      router.navigate(['/not-authorised']);
      return false;
    }
    return true;
  };
}

export function adminAuth(): CanActivateFn {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return (route, state) => {
    const partnerStore = inject(PartnerStore);
    const store = inject(Store);
    const router: Router = inject(Router);

    if (store.authToken()) {
      store.clearSession();
      router.navigate(['/partner/login']);
      return true;
    }

    // unauthorised check and redirect
    if (!partnerStore.partnerAuth()) {
      router.navigate(['/partner/login']);
      return false;
    }

    return true;
  };
}

export function adminPublicAuth(): CanActivateFn {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  return (route, state) => {
    const partnerStore = inject(PartnerStore);
    const store = inject(Store);
    const router: Router = inject(Router);

    if (store.authToken()) {
      store.clearSession();
      router.navigate(['/partner/login']);
      return true;
    }

    // unauthorised check and redirect
    if (partnerStore.partnerAuth()) {
      router.navigate(['admin-redirect']);
      return false;
    }

    return true;
  };
}
